const toObject = (value) => (value && typeof value === 'object' ? value : {})

const normalizeArrayHoles = (value) => {
    if (Array.isArray(value)) {
        return value.filter((item) => item !== undefined)
    }

    return value
}

// Supports both parsed nested query and flat bracket syntax like filter[product_types][0].
export const extractQueryObjectByPrefix = (query = {}, prefix = 'filter') => {
    const safeQuery = toObject(query)
    const directValue = safeQuery[prefix]

    if (directValue && typeof directValue === 'object') {
        return directValue
    }

    const parsed = {}
    const pattern = new RegExp(`^${prefix}\\[([^\\]]+)\\](?:\\[(\\d+)\\])?$`)

    Object.entries(safeQuery).forEach(([key, value]) => {
        const match = key.match(pattern)
        if (!match) return

        const field = match[1]
        const index = match[2]

        if (index != null) {
            if (!Array.isArray(parsed[field])) {
                parsed[field] = []
            }
            parsed[field][Number(index)] = value
            return
        }

        parsed[field] = value
    })

    return Object.fromEntries(Object.entries(parsed).map(([key, value]) => [key, normalizeArrayHoles(value)]))
}

export const extractRouteFilters = (query = {}) => extractQueryObjectByPrefix(query, 'filter')
